import axios from 'axiosConfig';
import dayjs from 'dayjs';

// Generic print service factory
export const createPrintService = (reportName) => {
  return (primaryId, secondaryId = null) => {
    return axios.post("/api/reports/reportdata", {
      reportName,
      loanMasterId: primaryId,
      loanActivityId: secondaryId ?? null
    });
  };
};

// Specific print services
export const printLoanActivityReport = createPrintService("Loan Activity");
export const printLoanMasterReport = createPrintService("Loan Master");

const toNumber = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

  const parsed = Number(String(value ?? '').replace(/[^0-9.-]/g, ''));
  return Number.isFinite(parsed) ? parsed : 0;
};

const toIsoDate = (value) => {
  if (!value) return null;

  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.toISOString() : null;
};

export const printAmortizationReport = (amortization = {}, scheduleList = []) => {
  const request = {
    amortization: {
      loanName: amortization.loanName ?? amortization.name ?? '',
      notes: amortization.notes ?? '',
      loanAmount: toNumber(amortization.loanamount),
      monthsAmortized: toNumber(amortization.monthsamortized),
      interestRate: toNumber(amortization.interestrate),
      paymentFrequency: toNumber(amortization.paymentFrequency),
      additionalServiceFee: toNumber(amortization.additionalsvcfee),
      amortized: Boolean(amortization.amor),
      daily: Boolean(amortization.daily),
      dailyValues: amortization.dailyValues ? toNumber(amortization.dailyValues) : null,
      approvalDate: toIsoDate(amortization.approvalDate),
      firstDueDate: toIsoDate(amortization.firstDueDate),
      maturityDate: toIsoDate(amortization.maturityDate),
    },
    scheduleList: scheduleList.map((row) => ({
      pay: toNumber(row.Pay),
      dueDate: toIsoDate(row.duedate),
      balance: toNumber(row.balance),
      payment: toNumber(row.payment),
      principal: toNumber(row.principal),
      interest: toNumber(row.interest),
      accruedInterest: toNumber(row.accruedinterest),
    })),
  };

  return axios.post("/api/reports/amortization", request);
};
